<template>
  <div>
    <div v-if="bubbleMessages.length == 0" class="primary-color pl-1">{{ $t('No reply') }}</div>
    <div>
      <ul style="margin: 0; padding: 0">
        <li
          style="list-style-type: none"
          v-for="(item, index) in bubbleMessages"
          :key="'intent_item_' + index"
        >
          <template>
            <move-vertical
              :index="index"
              :max="bubbleMessages.length"
              @onMove="onMove(index, $event)"
              style="
                width: 20px;
                min-width: 20px;
                display: inline-block;
                float: left;
                margin-right: 10px;
              "
            >
              <a
                href="javascript:void(0);"
                v-if="bubbleMessages && bubbleMessages.length > 0"
                @click="onDelete(index)"
                style="float: left; margin-left: 5px"
              >
                <i class="fas fa-trash"></i> </a
              >&nbsp;
            </move-vertical>
            <!-- <template v-if="item.type == 'text' && isVerifySlip">
              <intent-verify-slip
                :correct.sync="correctMsg[index].text"
                :incorrect.sync="incorrectMsg[index].text"
                :err.sync="errMsg[index].text"
                :errors="errors"
                :isLineShopping="isLineShopping"
                :channel="channel"
                :index="index"
                :indexAlternative="indexAlternative"
                v-if="correctMsg[index] && incorrectMsg[index] && errMsg[index]"
              ></intent-verify-slip>
            </template> -->
            <template v-if="item.type == 'text'">
              <template v-if="item.text == '{viewsummary}'">
                <view-cart-summary-viewer></view-cart-summary-viewer>
                <div class="clearfix"></div>
              </template>
              <template v-else>
                <div
                  class="message"
                  style="
                    float: left;
                    max-width: 240px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    cursor: pointer;
                  "
                >
                  <div style="font-size: 12px; color: black">
                    <template>
                      <div
                        style="border-radius: 12px; padding: 8px 6px 2px; background-color: #f1f0f0"
                      >
                        <div
                          class="form-control"
                          :class="{
                            'has-error': errors.has(
                              'answer_' + (indexAlternative - 1) + '_text_' + index
                            )
                          }"
                        >
                          <autoresize-textarea
                            maxlength="2000"
                            :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                            class
                            :placeholder="$t('Chatbot answers')"
                            v-model.trim="item.text"
                            name="answer"
                            data-vv-as="Answer"
                            :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                            v-validate
                            style="resize: none; display: inherit; margin-bottom: 5px;min-width: 200px;"
                            :key="`product_${timestamp}_${index}`"
                            v-if="isRenderText === undefined || isRenderText"
                          ></autoresize-textarea>
                          <v-layout>
                            <v-flex class="error--text">
                              {{
                                errors.first('answer_' + (indexAlternative - 1) + '_text_' + index)
                              }}
                            </v-flex>
                            <v-flex shrink class="text-xs-right caption grey--text">
                              {{ item.text.length }}/2000
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="clearfix"></div>

                  <small
                    class="caption warning--text"
                    v-if="!isLineShopping && (channel === 'all' || ['instagram'].includes(channel))"
                    >* {{ $t('instagram_1000_characters') }}</small
                  >
                </div>
                <intent-prefill
                  :isWelcome="isWelcome"
                  :isIntent="isIntent"
                  :followUp="followUp"
                  v-if="isHasPrefill && !isLineShopping"
                  @addIntentPrefillGroup="
                    addIntentPrefillGroup(indexAlternative - 1, index, $event)
                  "
                  @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
                ></intent-prefill>
              </template>
            </template>
            <template v-if="item.type == 'button'">
              <div
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  max-width: 240px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                "
              >
                <div style="font-size: 12px; color: black">
                  <template>
                    <div
                      style="
                        padding: 8px 6px 2px;
                        background-color: #f1f0f0;
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                      "
                    >
                      <div
                        class="form-control"
                        :class="{
                          'has-error': errors.has(
                            'answer_' + (indexAlternative - 1) + '_text_' + index
                          )
                        }"
                      >
                        <autoresize-textarea
                          maxlength="640"
                          :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                          class
                          :placeholder="$t('Chatbot answers')"
                          v-model="item.text"
                          name="answer"
                          data-vv-as="Answer"
                          :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                          v-validate
                          style="resize: none; display: inherit; margin-bottom: 5px"
                          :key="`product_${timestamp}_${index}_answers`"
                        ></autoresize-textarea>

                        <v-layout>
                          <v-flex class="error--text">
                            {{
                              errors.first('answer_' + (indexAlternative - 1) + '_text_' + index)
                            }}
                          </v-flex>
                          <v-flex shrink class="text-xs-right caption grey--text">
                            {{ item.text.length }}/640
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="clearfix"></div>
                <div
                  style="
                    float: left;
                    width: 100%;
                    border: 1px solid #eee;
                    border-bottom-left-radius: 12px;
                    border-bottom-right-radius: 12px;
                  "
                >
                  <ul class="message-group message-group-flush" style="margin-bottom: 0px">
                    <template v-if="item.buttons && item.buttons.length > 0">
                      <template v-for="(button, bindex) in item.buttons">
                        <li
                          v-if="button"
                          class="message-group-item text-xs-center"
                          style="
                            position: relative;
                            border-left: none;
                            border-right: none;
                            border-bottom: none;
                            border-radius: 0px;
                            padding: 5px 10px;
                          "
                          :style="{ 'border-top': bindex != 0 ? '1px solid #eee' : 'none' }"
                          :key="bindex"
                        >
                          <add-generic-button
                            :isEdit="true"
                            :ref="'buttonGeneric_' + bindex"
                            :key="'group_button_' + bindex + '_' + editTimestamp"
                            v-model="item.buttons[bindex]"
                            @onSave="editButton(index, bindex, $event)"
                          >
                            <div
                              slot="body"
                              class="text-xs-center"
                              style="overflow: auto; position: relative; width: 100%"
                            >
                              <v-layout row wrap>
                                <!-- <v-flex xs2 style="align-self: center;">
                                  <v-tooltip bottom v-if="checkBotTest(button)">
                                    <template v-slot:activator="{ on }">
                                      <v-icon
                                        v-on="on"
                                        :key="editTimestamp"
                                        style="font-size: 15px; color:rgb(76, 175, 80)"
                                        >circle</v-icon
                                      >
                                    </template>
                                    <span
                                      >ปุ่มนี้
                                      <strong>" มี "</strong> การเชื่อมต่อไปยังบทสนทนาใหม่เรียบร้อย
                                      ( หากมีการสร้างบทสนทนาเป็น
                                      <strong> ปุ่มกด แบบข้อความ </strong>
                                      จะต้องมีการสร้างบทสนทนาใหม่ เพื่อสร้างคำตอบของปุ่มกดนี้
                                    </span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-else>
                                    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on" style="font-size: 15px; color:red"
                                        >circle</v-icon
                                      >
                                    </template>
                                    <span
                                      >ปุ่มนี้
                                      <strong>" ยังไม่มี "</strong> การเชื่อมต่อไปยังบทสนทนาใหม่ (
                                      หากมีการสร้างบทสนทนาเป็น <strong> ปุ่มกด แบบข้อความ </strong>
                                      จะต้องมีการสร้างบทสนทนาใหม่ เพื่อสร้างคำตอบของปุ่มกดนี้
                                    </span>
                                  </v-tooltip>
                                </v-flex> -->
                                <v-flex xs12>
                                  <div style="color: #0084ff" :title="button.title">
                                    {{ button.title | truncate(12) }}
                                  </div>
                                  <div class="clearfix"></div>

                                  <div style="margin: 0; font-size: 10px; color: darkgrey">
                                    <div v-if="button.type == 'web_url'" :title="button.url">
                                      {{ button.url | truncate(20) }}
                                    </div>
                                    <div
                                      v-else-if="button.type == 'postback'"
                                      :title="button.payload"
                                    >
                                      {{ button.payload | truncate(20) }}
                                    </div>
                                    <div
                                      v-else-if="button.type == 'phone_number'"
                                      :title="button.payload"
                                    >
                                      {{ button.payload | truncate(20) }}
                                    </div>
                                    <div v-else>&nbsp;</div>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </div>

                            <template slot="append">
                              <v-list-tile
                                :disabled="bindex <= 0"
                                @click="onMoveButton(bindex, 'up', item)"
                              >
                                <v-list-tile-title
                                  :style="bindex <= 0 ? `color: lightgrey` : ''"
                                  class="primary-color"
                                  >{{ $t('Move up') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile
                                :disabled="bindex >= item.buttons.length - 1"
                                @click="onMoveButton(bindex, 'down', item)"
                              >
                                <v-list-tile-title
                                  :style="
                                    bindex >= item.buttons.length - 1 ? `color: lightgrey` : ''
                                  "
                                  class="primary-color"
                                  >{{ $t('Move down') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile @click="deleteButton(index, bindex)">
                                <v-list-tile-title class="primary-color">{{
                                  $t('Delete')
                                }}</v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </add-generic-button>
                        </li>
                      </template>
                    </template>
                    <li
                      v-if="item.buttons && item.buttons.length < 3"
                      class="message-group-item"
                      style="
                        border-left: none;
                        border-right: none;
                        border-bottom: none;
                        border-radius: 0px;
                        text-align: center;
                        padding: 10px 0px;
                      "
                      :style="{
                        'border-top': item.buttons.length != 0 ? '1px solid #eee' : 'none'
                      }"
                    >
                      <add-generic-button
                        :key="'group_new_button_' + saveTimestamp"
                        v-model="newButton"
                        @onSave="addNewButton(index, $event)"
                      >
                        <template slot="body">
                          <span class="fas fa-plus"></span>
                          {{ $t('Add button') }}
                        </template>
                      </add-generic-button>
                    </li>
                  </ul>
                </div>
                <input
                  type="hidden"
                  v-validate="''"
                  :name="'answer_' + (indexAlternative - 1) + '_buttons_' + index"
                  v-model="item.buttons.length"
                  data-vv-as="Buttons"
                />
                <div
                  class="form-control"
                  :class="{
                    'has-error': errors.has(
                      'answer_' + (indexAlternative - 1) + '_buttons_' + index
                    )
                  }"
                >
                  <span
                    class="text-error"
                    v-show="errors.has('answer_' + (indexAlternative - 1) + '_buttons_' + index)"
                  >
                    {{ errors.first('answer_' + (indexAlternative - 1) + '_buttons_' + index) }}
                  </span>
                </div>
              </div>
              <intent-prefill
                v-if="!isLineShopping && !isAdsPreview"
                :isWelcome="isWelcome"
                :isIntent="isIntent"
                :followUp="followUp"
                @addIntentPrefillGroup="addIntentPrefillGroup(indexAlternative - 1, index, $event)"
                @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
              ></intent-prefill>
            </template>
            <template v-else-if="item.type == 'image'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <uploadfile
                  ref="answer"
                  v-model="item.image_url"
                  :height="181"
                  data-vv-as="Image"
                  :data-vv-name="'answer_' + (indexAlternative - 1) + '_image_' + index"
                  v-validate
                ></uploadfile>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="item.type == 'video'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  min-height: 150px;
                  border: 1px solid #eee;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <template v-if="item.picture">
                  <v-img :src="item.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                </template>
                <template v-else>
                  <v-responsive :aspect-ratio="16 / 9">
                    <div style="background: #eee; height: 100%"></div>
                  </v-responsive>
                </template>

                <v-layout
                  fill-height
                  absolute
                  class="text-xs-center"
                  style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                >
                  <div style="margin: auto; width: 100%" :title="item.source" :alt="item.source">
                    <v-btn
                      fab
                      small
                      depressed
                      color="white"
                      :href="item.source || item.sourceline"
                      target="_blank"
                    >
                      <v-icon large>play_circle_filled</v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </div>
              <div class="clearfix"></div>
            </template>

            <template v-else-if="item.custom_type === 'catalogue' && item.type === 'generic'">
              <intent-generic-manage
                :isCatalogue="true"
                v-model="item.data"
                :altText="item.altText"
                :isNotAltText="isNotAltText"
                :isNotRatio="isNotRatio"
                :ratio="item.ratio"
                @changealtText="changealtText(index, $event)"
                @changeRatio="changeRatio(index, $event)"
                @deleteMessage="onDelete(index)"
              ></intent-generic-manage>
            </template>

            <template v-else-if="item.type === 'generic'">
              <div style="display: flow-root;">
                <intent-generic-manage
                  v-model="item.data"
                  :altText="item.altText"
                  :isNotAltText="isNotAltText"
                  :isNotRatio="isNotRatio"
                  :ratio="item.ratio"
                  @changealtText="changealtText(index, $event)"
                  @changeRatio="changeRatio(index, $event)"
                  @deleteMessage="onDelete(index)"
                ></intent-generic-manage>

                <small
                  class="caption warning--text"
                  v-if="
                    !isLineShopping &&
                      (channel === 'all' || (['whatsapp'].includes(channel) && countMenulist > 0))
                  "
                >
                  {{ $t('waring_whatsapp_only4') }}
                </small>
              </div>
            </template>

            <template v-else-if="item.type == 'ntn_template'">
              <intent-ntn-manage
                v-model="bubbleMessages[index]"
                :ratio="item.ratio"
                @changealtText="changealtText(index, $event)"
                @changeRatio="changeRatio(index, $event)"
                @deleteMessage="onDelete(index)"
              ></intent-ntn-manage>
            </template>

            <template v-else-if="item.type == 'payment'">
              <div
                style="
                  padding: 1em;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 240px;
                  min-height: 100px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  background-color: #eeeeee;
                "
              >
                <v-layout style="margin-bottom: 0px; word-break: break-all" row>
                  <vue-simple-svg
                    :filepath="'/static/img/assets/get_started/payment.svg'"
                    width="40px"
                    height="40px"
                    class="img"
                    style="
                      border-right: 2px solid #c5c5c5;
                      padding-right: 10px;
                      padding-top: 1em;
                      padding-bottom: 1em;
                      vertical-align: middle;
                    "
                  />
                  <v-flex style="padding-left: 1em">
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Detail') }}:</strong>
                      <br />
                      {{ item.data.detail }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Amount') }}:</strong>
                      <br />
                      {{ item.data.amount }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Delivery Method') }}:</strong>
                      <br />
                      {{ item.data.delivery.name }}
                    </div>
                    <div style="margin-bottom: 10px; white-space: break-spaces">
                      <strong>{{ $t('Response Message') }}:</strong>
                      <br />
                      {{ item.data.response }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-btn
                  @click="paymentForm(item, index)"
                  fab
                  outline
                  color="primary"
                  class="extra-small"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
              <!-- <intent-generic-manage v-model="item.data" @deleteMessage="onDelete(index)"></intent-generic-manage> -->
            </template>

            <div v-else-if="item.type == 'meta_pay'">
              <div>
                <div
                  style="
                    padding: 1em;
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    width: 240px;
                    min-height: 100px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    background-color: #eeeeee;
                  "
                >
                  <v-layout style="margin-bottom: 0px; word-break: break-all" row>
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/payment.svg'"
                      width="35px"
                      height="35px"
                      class="img"
                      style="
                        padding-right: 10px;
                        padding-top: 1em;
                        padding-bottom: 1em;
                        vertical-align: middle;
                      "
                    />
                    <h4 style="color: #000; align-self: center; font-size: 16px; margin-left: 11px">
                      ฿{{ item.amount }} ส่งคำขอให้ชำระเงินแล้ว
                    </h4>
                  </v-layout>
                  <h4
                    class="text-xs-center"
                    style="background: #fff; padding: 12px; border-radius: 14px; color: #000"
                  >
                    ชำระเงิน
                  </h4>
                </div>
                <div>
                  <v-btn
                    @click="metaPayForm(item, index)"
                    fab
                    outline
                    color="primary"
                    class="extra-small"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="clearfix"></div>
              <small>{{ $t('available_for_facebook_only') }}</small>
            </div>

            <template
              v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(item.type)"
            >
              <span>
                <view-cart-summary-viewer2 :items="item.data"></view-cart-summary-viewer2>
              </span>
              <span style="inline-block">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        @click="editRemoveAndAdd(item, index)"
                        fab
                        outline
                        color="primary"
                        class="extra-small"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>
                </div>
              </span>
            </template>
            <template v-else-if="item.type == 'welcome_message'">
              <v-layout>
                <v-flex
                  v-if="channel == 'all' && hasWCMultiChannel"
                  shrink
                  class="channel"
                  style="border-right: 1px solid #eee"
                >
                  <ChannelTab
                    @onChange="changeWelcomeChannelTab"
                    :tab="welcome_channel"
                  ></ChannelTab>
                </v-flex>
                <v-flex>
                  <message-viewer
                    :key="`welcome_${channel}`"
                    v-model="welcomeMessage"
                    :channel="channel == 'all' ? welcome_channel : channel"
                  ></message-viewer>
                </v-flex>
              </v-layout>
              <!-- <intent-getstarted v-if="welcomeMessage" v-model="welcomeMessage"></intent-getstarted> -->
            </template>
            <template v-else-if="item.type == 'flex'">
              <intent-line-flex
                v-model="bubbleMessages[index].contents"
                :altText.sync="bubbleMessages[index].altText"
                @deleteMessage="onDelete(index)"
              ></intent-line-flex>
            </template>
            <template v-else-if="item.type == 'imagemap'">
              <intent-line-image-map
                v-model="bubbleMessages[index]"
                @deleteMessage="onDelete(index)"
              ></intent-line-image-map>
            </template>
            <template v-else-if="item.type == 'sticker'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  border: 1px solid #eee;
                  width: 100%;
                  max-width: 180px;
                "
              >
                <v-img
                  aspect-ratio="1"
                  :src="`/static/img/assets/stickers/${item.packageid}/${item.stickerid}.png`"
                  :lazy-src="`/static/img/assets/stickers/${item.packageid}/${item.stickerid}.png`"
                  style="width: 100%"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <div class="spinner text-xs-center">
                        <img
                          class="z-loop"
                          src="/static/img/assets/loading/z-loop.png"
                          alt="loading"
                        />
                      </div>
                    </v-layout>
                  </template>
                </v-img>
                <div
                  style="background: #4bd64b; padding: 10px; line-height: 20px"
                  small
                  disabled
                  class="white--text"
                >
                  {{ $t('This item will be shown only on Line Chatbot') }}
                </div>
              </div>
            </template>
            <div class="clearfix"></div>
            <div class="form-control has-error" style="margin-left: 30px">
              <span
                class="text-error"
                v-show="errors.has('answer_' + (indexAlternative - 1) + '_image_' + index)"
                >{{ errors.first('answer_' + (indexAlternative - 1) + '_image_' + index) }}</span
              >
            </div>
            <div style="margin-bottom: 10px"></div>
          </template>
        </li>
      </ul>
    </div>

    <v-layout class="mb-3" :class="{ 'red--text': bubbleCount >= addLimit }">
      <v-flex class="text-xs-right caption">{{ bubbleCount }} / {{ addLimit }}</v-flex>
    </v-layout>

    <template v-if="selectedBot.pagetype != 'enterprise'">
      <router-link
        :to="'/' + $i18n.locale() + '/upgrade'"
        v-if="$store.getters.getPackage != 'premium'"
        class="caption primary--text"
        v-show="bubbleCount == 5"
      >
        <v-icon small color="primary">lock</v-icon>
        {{ $t('For facebook, If you want to increase 5 more items, please upgrade to premium') }}
      </router-link>
    </template>

    <div class="mt-2 caption warning--text" v-if="$store.getters.getPackage == 'normal'">
      <v-icon small color="warning">warning</v-icon>
      {{ $t('Warning: Basic package (Free), only 2 chatbot answer items can be set up') }}
      <a
        style="text-decoration-line: underline"
        @click="$router.push('/' + $store.getters.currentLang + '/upgrade')"
        >{{ $t('To upgrade, click') }}</a
      >
    </div>

    <div class="mt-2 caption warning--text" v-if="isBroadCast && remarkNtn && isIgType">
      <v-icon small color="warning">warning</v-icon>
      {{ $t('warning_broadcast') }}
    </div>

    <div class="mt-2 caption warning--text" v-if="bubbleCount > 5">
      <v-icon small color="warning">warning</v-icon>
      {{ $t('Warning: only 5 items will be shown on Line Chatbot') }}
    </div>
    <div class="mt-2 caption warning--text" v-if="isBroadCast && remarkNtn && !isIgType">
      <v-icon small color="warning">warning</v-icon>
      {{ $t('warning_recurring_notification') }}
    </div>

    <div
      style="overflow-x: auto; margin-top: 15px"
      class="pl-3"
      v-if="!isNotAltText || (isNotAltText && bubbleCount < 1)"
    >
      <label for class="caption">{{ $t('Add more item') }}</label>
      <!-- new style -->
      <ul class="customize-message-tool">
        <template v-if="isFirstAnnouncement">
          <template v-for="(item, index) in firstAnnouncementTool">
            <li
              :key="index"
              v-ripple
              @click="
                item.type === 'meta'
                  ? metaPayForm()
                  : item.type === 'gbPay'
                  ? paymentForm()
                  : item.type === 'cart'
                  ? cartaddremove()
                  : item.type === 'catalogue'
                  ? addIntentItem('catalogue')
                  : addIntentItem(item.activeBubble)
              "
              v-if="activeBubbles.includes(item.activeBubble)"
              v-tooltip.top="item.itemTooltip"
              :class="item.classItem"
            >
              <vue-simple-svg :filepath="item.imgFilePath" width="40px" height="40px" class="img" />
              {{ $t(item.name) }}
              <div
                style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                v-if="item.isBroadCast"
              >
                <v-premium-lock v-if="item.name != 'Message'" :inline="true"></v-premium-lock>
              </div>
              <div
                style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                v-if="item.isAdvance"
              >
                <v-premium-lock2
                  type="advanced"
                  text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                ></v-premium-lock2>
              </div>
            </li>
          </template>
        </template>
        <template v-else-if="!isBroadCast && !isLineShopping">
          <template v-if="channel == 'all'">
            <template v-for="(item, index) in sortMessageTool">
              <template v-if="item.condition">
                <li
                  :key="index"
                  v-ripple
                  @click="
                    item.type === 'meta'
                      ? metaPayForm()
                      : item.type === 'gbPay'
                      ? paymentForm()
                      : item.type === 'cart'
                      ? cartaddremove()
                      : item.type === 'catalogue'
                      ? addIntentItem('catalogue')
                      : addIntentItem(item.activeBubble)
                  "
                  v-if="activeBubbles.includes(item.activeBubble)"
                  v-tooltip.top="item.itemTooltip"
                  :class="item.classItem"
                >
                  <vue-simple-svg
                    :filepath="item.imgFilePath"
                    width="40px"
                    height="40px"
                    class="img"
                  />
                  {{ $t(item.name) }}
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isBroadCast"
                  >
                    <v-premium-lock
                      :inline="true"
                      v-if="item.type === 'meta' || item.type === 'cart'"
                    ></v-premium-lock>
                  </div>
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isAdvance"
                  >
                    <v-premium-lock2
                      type="advanced"
                      text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2>
                  </div>
                </li>
              </template>
            </template>
          </template>
          <template v-else-if="channel == 'facebook'">
            <template v-for="(item, index) in sortFacebookTool">
              <template v-if="item.condition">
                <li
                  :key="index"
                  v-ripple
                  @click="
                    item.type === 'meta'
                      ? metaPayForm()
                      : item.type === 'gbPay'
                      ? paymentForm()
                      : item.type === 'cart'
                      ? cartaddremove()
                      : item.type === 'catalogue'
                      ? addIntentItem('catalogue')
                      : addIntentItem(item.activeBubble)
                  "
                  v-if="activeBubbles.includes(item.activeBubble)"
                  v-tooltip.top="item.itemTooltip"
                  :class="item.classItem"
                >
                  <vue-simple-svg
                    :filepath="item.imgFilePath"
                    width="40px"
                    height="40px"
                    class="img"
                  />
                  {{ $t(item.name) }}
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isBroadCast"
                  >
                    <v-premium-lock :inline="true"></v-premium-lock>
                  </div>
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isAdvance"
                  >
                    <v-premium-lock2
                      type="advanced"
                      text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2>
                  </div>
                </li>
              </template>
            </template>
          </template>
          <template v-else-if="channel == 'line'">
            <template v-for="(item, index) in sortlineTool">
              <template v-if="item.condition">
                <li
                  :key="index"
                  v-ripple
                  @click="
                    item.type === 'meta'
                      ? metaPayForm()
                      : item.type === 'gbPay'
                      ? paymentForm()
                      : item.type === 'cart'
                      ? cartaddremove()
                      : item.type === 'catalogue'
                      ? addIntentItem('catalogue')
                      : addIntentItem(item.activeBubble)
                  "
                  v-if="activeBubbles.includes(item.activeBubble)"
                  v-tooltip.top="item.itemTooltip"
                  :class="item.classItem"
                >
                  <vue-simple-svg
                    :filepath="item.imgFilePath"
                    width="40px"
                    height="40px"
                    class="img"
                  />
                  {{ $t(item.name) }}
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isBroadCast"
                  ></div>
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isAdvance"
                  >
                    <v-premium-lock2
                      type="advanced"
                      text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2>
                  </div>
                </li>
              </template>
            </template>
          </template>
          <template v-else-if="channel == 'instagram'">
            <template v-for="(item, index) in sortIgTool">
              <template v-if="item.condition">
                <li
                  :key="index"
                  v-ripple
                  @click="
                    item.type === 'meta'
                      ? metaPayForm()
                      : item.type === 'gbPay'
                      ? paymentForm()
                      : item.type === 'cart'
                      ? cartaddremove()
                      : item.type === 'catalogue'
                      ? addIntentItem('catalogue')
                      : addIntentItem(item.activeBubble)
                  "
                  v-if="activeBubbles.includes(item.activeBubble)"
                  v-tooltip.top="item.itemTooltip"
                  :class="item.classItem"
                >
                  <vue-simple-svg
                    :filepath="item.imgFilePath"
                    width="40px"
                    height="40px"
                    class="img"
                  />
                  {{ $t(item.name) }}
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isBroadCast"
                  ></div>
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isAdvance"
                  >
                    <v-premium-lock2
                      type="advanced"
                      text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2>
                  </div>
                </li>
              </template>
            </template>
          </template>
          <template v-else-if="channel == 'google'">
            <template v-for="(item, index) in sortGoogleTool">
              <template v-if="item.condition">
                <li
                  :key="index"
                  v-ripple
                  @click="
                    item.type === 'meta'
                      ? metaPayForm()
                      : item.type === 'gbPay'
                      ? paymentForm()
                      : item.type === 'cart'
                      ? cartaddremove()
                      : item.type === 'catalogue'
                      ? addIntentItem('catalogue')
                      : addIntentItem(item.activeBubble)
                  "
                  v-if="activeBubbles.includes(item.activeBubble)"
                  v-tooltip.top="item.itemTooltip"
                  :class="item.classItem"
                >
                  <vue-simple-svg
                    :filepath="item.imgFilePath"
                    width="40px"
                    height="40px"
                    class="img"
                  />
                  {{ $t(item.name) }}
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isBroadCast"
                  ></div>
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isAdvance"
                  >
                    <v-premium-lock2
                      type="advanced"
                      text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2>
                  </div>
                </li>
              </template>
            </template>
          </template>
          <template v-else-if="channel == 'whatsapp'">
            <template v-for="(item, index) in sortWhatsApp">
              <template v-if="item.condition">
                <li
                  :key="index"
                  v-ripple
                  @click="
                    item.type === 'meta'
                      ? metaPayForm()
                      : item.type === 'gbPay'
                      ? paymentForm()
                      : item.type === 'cart'
                      ? cartaddremove()
                      : item.type === 'catalogue'
                      ? addIntentItem('catalogue')
                      : addIntentItem(item.activeBubble)
                  "
                  v-if="activeBubbles.includes(item.activeBubble)"
                  v-tooltip.top="item.itemTooltip"
                  :class="item.classItem"
                >
                  <vue-simple-svg
                    :filepath="item.imgFilePath"
                    width="40px"
                    height="40px"
                    class="img"
                  />
                  {{ $t(item.name) }}
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isBroadCast"
                  ></div>
                  <div
                    style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                    v-if="item.isAdvance"
                  >
                    <v-premium-lock2
                      type="advanced"
                      text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2>
                  </div>
                </li>
              </template>
            </template>
          </template>
        </template>
        <template v-else-if="isBroadCast">
          <template v-for="(item, index) in sortBroadcastTool">
            <template v-if="item.condition">
              <li
                :key="index"
                v-ripple
                @click="
                  item.type === 'meta'
                    ? metaPayForm()
                    : item.type === 'gbPay'
                    ? paymentForm()
                    : item.type === 'cart'
                    ? cartaddremove()
                    : item.type === 'catalogue'
                    ? addIntentItem('catalogue')
                    : addIntentItem(item.activeBubble)
                "
                v-if="activeBubbles.includes(item.activeBubble)"
                v-tooltip.top="item.itemTooltip"
                :class="item.classItem"
              >
                <vue-simple-svg
                  :filepath="item.imgFilePath"
                  width="40px"
                  height="40px"
                  class="img"
                />
                {{ $t(item.name) }}
                <div
                  style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                  v-if="item.isBroadCast"
                >
                  <v-premium-lock v-if="item.name != 'Message'" :inline="true"></v-premium-lock>
                </div>
                <div
                  style="position: absolute; left: 0; right: 5px; top: 0; text-align: right"
                  v-if="item.isAdvance"
                >
                  <v-premium-lock2
                    type="advanced"
                    text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                  ></v-premium-lock2>
                </div>
              </li>
            </template>
          </template>
        </template>
        <template v-else-if="isLineShopping">
          <li
            v-ripple
            @click="addIntentItem('text')"
            v-if="activeBubbles.includes('text')"
            v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
            :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
          >
            <vue-simple-svg
              :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
              width="40px"
              height="40px"
              class="img"
            />
            {{ $t('Message') }}
          </li>
        </template>
      </ul>
    </div>

    <input
      type="hidden"
      name="bubbleLimit"
      :data-vv-as="$t('Chatbot answers') + ' ' + indexAlternative"
      :value="bubbleCount"
      v-validate="'max_value:' + addLimit"
    />

    <v-dialog v-model="showLineFlex" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <h3 class="primary--text pa-2">Line Flex Message</h3>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddFlexMessage">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="flexMessage">
          <intent-line-flex-message
            v-model="flexMessage.contents"
            :altTextValue.sync="flexMessage.altText"
          ></intent-line-flex-message>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLineImageMap" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <h3 class="primary--text pa-2">Line Image Map</h3>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddImageMap">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="showLineImageMap">
          <intent-line-image-map-message
            v-model="imageMap"
            @oncancel="cancelAddImageMap"
            @onsave="saveAddImageMap"
          ></intent-line-image-map-message>
        </v-card-text>
      </v-card>
    </v-dialog>

    <modal-video v-model="showVideo" @onAddVideo="addVideo"></modal-video>
    <modal-meta-pay
      v-if="metaPayDialog"
      v-model="metaPayDialog"
      :valueMetaPay="valueMetaPay"
      @addIntentItem="addIntentItem"
      @updateMetaPaymentItem="updateMetaPaymentItem($event)"
    ></modal-meta-pay>
    <intent-gb-prime
      v-if="gbprimeDialog"
      v-model="gbprimeDialog"
      :gbprimeValue="modalGbprime"
      @addIntentItem="addIntentItem"
      @updatePaymentItem="updatePaymentItem($event)"
    ></intent-gb-prime>
    <v-dialog scrollable v-model="showCartaddremove" max-width="800">
      <IntentCartAddRemove
        :isBroadCast="isBroadCast"
        :isWelcome="isWelcome"
        :isComment="false"
        :data="showCartaddremoveTemp"
        v-if="showCartaddremove"
        @addIntentItem="addIntentItem"
        @updateRemoveAndAdd="updateRemoveAndAdd($event)"
        @close="closecartaddremove"
      ></IntentCartAddRemove>
    </v-dialog>

    <sticker-list v-model="showLineSticker" @sendSticker="addSticker"></sticker-list>
  </div>
</template>

<script>
import IntentGroupItem from './IntentGroupItem.js'

export default {
  props: [
    'channel',
    'isBroadCast',
    'isWelcome',
    'isLineShopping',
    'messagesType',
    'isAdsPreview',
    'isVerifySlip'
  ],
  data: function() {
    return {}
  },
  mixins: [IntentGroupItem],
  mounted() {}
}
</script>

<style lang="scss">
.customize-message-tool .disabled {
  color: #d4d4d4 !important;
  background-color: #efefef !important;
}
.customize-message-tool .disabled .img {
  fill: #d4d4d4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGroupItem.vue